import Currency from './currency';

var PriceBreakdown = Currency.extend({

    defaults: {
        quantity: 1,
        price: 0.00,
        selected: false
    }

});

export default PriceBreakdown;
